import { render, staticRenderFns } from "./FormPerson.vue?vue&type=template&id=4d5bb47f&"
import script from "./FormPerson.vue?vue&type=script&lang=js&"
export * from "./FormPerson.vue?vue&type=script&lang=js&"
import style0 from "./FormPerson.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports